// extracted by mini-css-extract-plugin
export var actions = "_mg-g";
export var benefitCard = "_mg-b";
export var benefitIcon = "_mg-d";
export var benefitLabel = "_mg-f";
export var benefits = "_mg-a";
export var benefitsSection = "_mg-8";
export var bodyText = "_mg-7";
export var closeButton = "_mg-2";
export var content = "_mg-3";
export var eyebrow = "_mg-4";
export var heading = "_mg-5";
export var image = "_mg-i";
export var imagePanel = "_mg-h";
export var modal = "_mg-0";
export var offerCard = "_mg-c";
export var offerIcon = "_mg-e";
export var sectionLabel = "_mg-9";
export var shell = "_mg-1";
export var title = "_mg-6";